// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconShare(Props) {
  var className = Props.className;
  var tmp = {
    height: "22",
    width: "25",
    fill: "none",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M24.3125 8.70312L15.3125 16.9531H13.8125V12.4531H10.0625C7.15625 12.4531 4.8125 14.8438 4.8125 17.7031C4.8125 19.9531 6.3125 21.4531 6.3125 21.4531C6.3125 21.4531 0.3125 19.2031 0.3125 13.2031C0.3125 8.65625 3.96875 4.95312 8.5625 4.95312H13.8125V0.453125H15.3125L24.3125 8.70312Z",
    fill: "currentColor"
  }));
}
IconShare.displayName = "IconShare";
var make = IconShare;
export { make };
/* react Not a pure module */